<template>
    <form>
        <div class="row">
            <div class="small-12 columns" :class="{ error: showHasNoVoucherRedeemedErrorText }">
                <label class="checkbox-label">
                    <input type="checkbox" class="checkbox-margin" v-model="caseData.has_no_voucher_redeemed"/>
                    <span>
                        Ja, ich möchte die von meinem Fitnessstudio während der Schließung erhobenen Beiträge zurückverlangen.
                        Einen Gutschein über die Beiträge habe ich nicht eingelöst.
                    </span>
                </label>
                <small class="error" v-if="showHasNoVoucherRedeemedErrorText">
                    {{ hasNoVoucherRedeemedErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showMandatorLawformErrorText }">
                <label>
                    Anrede
                    <select v-model="caseData.mandator_lawform">
                        <option
                            v-for="lawform in lawformSelectData"
                            :key="lawform.value"
                            :value="lawform.value"
                        >
                            {{lawform.text}}
                        </option>
                    </select>
                </label>
                <small class="error" v-if="showMandatorLawformErrorText">
                    {{ mandatorLawformErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showMandatorPrenameErrorText }">
                <label>
                    Vorname
                    <input type="text" v-model="caseData.mandator_prename"/>
                </label>
                <small class="error" v-if="showMandatorPrenameErrorText">
                    {{ mandatorPrenameErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showMandatorSurnameErrorText }">
                <label>
                    Nachname
                    <input type="text" v-model="caseData.mandator_surname"/>
                </label>
                <small class="error" v-if="showMandatorSurnameErrorText">
                    {{ mandatorSurnameErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showMandatorMailErrorText }">
                <label>
                    E-Mail Adresse
                    <input type="text" v-model="caseData.mandator_mail"/>
                </label>
                <small class="error" v-if="showMandatorMailErrorText">
                    {{ mandatorMailErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showContractNumberErrorText }">
                <label>
                    Kunden-/Vertragsnummer beim Fitnessstudio
                    <input type="text" v-model="caseData.contract_number"/>
                </label>
                <small class="error" v-if="showContractNumberErrorText">
                    {{ contractNumberErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showGymNameErrorText }">
                <label>
                    Name des Fitnessstudios
                    <input type="text" v-model="caseData.gym_name"/>
                </label>
                <small class="error" v-if="showGymNameErrorText">
                    {{ gymNameErrorText }}
                </small>
            </div>
            <div class="small-12 columns gym-mail-input-container" :class="{ error: showGymMailErrorText }">
                <label>
                    E-Mail Adresse des Fitnessstudios
                    <input class="gym-mail-input" :class="{ error: showGymMailErrorText }" type="text"
                           v-model="caseData.gym_mail"/>
                </label>
                <small class="error" v-if="showGymMailErrorText">
                    {{ gymMailErrorText }}
                </small>
            </div>
            <div @click.stop.prevent class="hint small-12 columns">
                <i>(Wo finde ich die E-Mail Adresse des Fitnessstudios?)
                    <span class="hint-text panel">
                        Im Impressum auf der Internetseite des Fitnessstudios muss eine E-Mail Adresse
                        angegeben werden, unter der die Bank rechtsgeschäftliche Erklärungen entgegennimmt.
                    </span>
                </i>
            </div>
            <div class="small-12 columns" :class="{ error: showMonthlyGymFeeErrorText }">
                <label>
                    Monatlicher Beitrag
                    <currency-input v-model="caseData.monthly_gym_fee" :options="viewData.currencyInputOptions"/>
                </label>
                <small class="error" v-if="showMonthlyGymFeeErrorText">
                    {{ monthlyGymFeeErrorText }}
                </small>
            </div>
            <div class="small-12 columns" :class="{ error: showMandatorIbanErrorText }">
                <label>
                    IBAN (für Rückerstattungen des Fitnessstudios)
                    <input type="text" v-model="caseData.mandator_iban"/>
                </label>
                <small class="error" v-if="showMandatorIbanErrorText">
                    {{ mandatorIbanErrorText }}
                </small>
            </div>
        </div>
    </form>
</template>

<script>
import TypeHelper from '../helper/TypeHelper';
import Validation from '../helper/Validation';
import CurrencyInput from './CurrencyInput';
import Lawforms from '../helper/Lawforms';

export default {
    name: 'GymFeeForm',
    components: { CurrencyInput },
    data: () => ({
        caseData: {
            gym_name:                   null,
            gym_mail:                   null,
            mandator_lawform:           null,
            mandator_prename:           null,
            mandator_surname:           null,
            mandator_mail:              null,
            mandator_iban:              null,
            contract_number:            null,
            monthly_gym_fee:            null,
            has_no_voucher_redeemed:    null,
        },
        validation: {
            isFormDirty: false,
            isGymNameDirty: false,
            isGymMailDirty: false,
            isMandatorLawformDirty: false,
            isMandatorPrenameDirty: false,
            isMandatorSurnameDirty: false,
            isMandatorMailDirty: false,
            isMandatorIbanDirty: false,
            isContractNumberDirty: false,
            isMonthlyGymFeeDirty: false,
            isHasNoVoucherRedeemedDirty: false
        },
        viewData: {
            currencyInputOptions: {
                "currency": "EUR",
                "currencyDisplay": "symbol",
                "valueRange": {
                    "min": 0
                },
                "hideCurrencySymbolOnFocus": true,
                "hideGroupingSeparatorOnFocus": true,
                "hideNegligibleDecimalDigitsOnFocus": true,
                "autoDecimalDigits": false,
                "autoSign": true,
                "useGrouping": true,
                "accountingSign": false
            }
        },
        lawformSelectData: [
            Lawforms.HERR,
            Lawforms.FRAU
        ],
    }),
    computed: {
        showGymNameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isGymNameDirty)
                    && TypeHelper.isNotNullOrUndefined(this.gymNameErrorText);
        },
        showGymMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isGymMailDirty)
                    && TypeHelper.isNotNullOrUndefined(this.gymMailErrorText);
        },
        showMandatorLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorLawformErrorText);
        },
        showMandatorPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorPrenameDirty)
                    && TypeHelper.isNotNullOrUndefined(this.mandatorPrenameErrorText);
        },
        showMandatorSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorSurnameDirty)
                    && TypeHelper.isNotNullOrUndefined(this.mandatorSurnameErrorText);
        },
        showMandatorMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorMailDirty)
                    && TypeHelper.isNotNullOrUndefined(this.mandatorMailErrorText);
        },
        showMandatorIbanErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorIbanDirty)
                    && TypeHelper.isNotNullOrUndefined(this.mandatorIbanErrorText);
        },
        showContractNumberErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isContractNumberDirty)
                    && TypeHelper.isNotNullOrUndefined(this.contractNumberErrorText);
        },
        showMonthlyGymFeeErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMonthlyGymFeeDirty)
                    && TypeHelper.isNotNullOrUndefined(this.monthlyGymFeeErrorText);
        },
        showHasNoVoucherRedeemedErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isHasNoVoucherRedeemedDirty)
                    && TypeHelper.isNotNullOrUndefined(this.hasNoVoucherRedeemedErrorText);
        },
        gymNameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.caseData.gym_name, validators);
        },
        gymMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.caseData.gym_mail, validators);
        },
        mandatorLawformErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.caseData.mandator_lawform, validators);
        },
        mandatorPrenameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.caseData.mandator_prename, validators);
        },
        mandatorSurnameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.caseData.mandator_surname, validators);
        },
        mandatorMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.caseData.mandator_mail, validators);
        },
        mandatorIbanErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isIban
            ];

            return Validation.runValidation(this.caseData.mandator_iban, validators);
        },
        contractNumberErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.caseData.contract_number, validators);
        },
        monthlyGymFeeErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.caseData.monthly_gym_fee, validators);
        },
        hasNoVoucherRedeemedErrorText()
        {
            let validators = [
                Validation.requiresCheck
            ];

            return Validation.runValidation(this.caseData.has_no_voucher_redeemed, validators);
        }
    },
    methods: {
        validateForm()
        {
            this.validation.isFormDirty = true;

            if (this.isFormValid())
                this.emitChangedData();
        },
        isFormValid()
        {
            let isValid = true;

            isValid = this.gymMailErrorText === null;
            isValid = isValid && (this.gymNameErrorText === null);
            isValid = isValid && (this.mandatorLawformErrorText === null);
            isValid = isValid && (this.mandatorPrenameErrorText === null);
            isValid = isValid && (this.mandatorSurnameErrorText === null);
            isValid = isValid && (this.mandatorMailErrorText === null);
            isValid = isValid && (this.mandatorIbanErrorText === null);
            isValid = isValid && (this.contractNumberErrorText === null);
            isValid = isValid && (this.monthlyGymFeeErrorText === null);
            isValid = isValid && (this.hasNoVoucherRedeemedErrorText === null);

            return isValid;
        },
        onFormDataValidated()
        {
            if(this.isFormValid())
                this.emitChangedData();
            else
                this.$emit('changeForm', null);
        },
        emitChangedData()
        {
            this.$emit('changeForm', this.caseData);
        }
    },
    watch: {
        'caseData.gym_name': function()
        {
            this.validation.isGymNameDirty = true;
        },
        'caseData.gym_mail': function()
        {
            this.validation.isGymMailDirty = true;
        },
        'caseData.mandator_lawform': function()
        {
            this.validation.isMandatorLawformDirty = true;
        },
        'caseData.mandator_prename': function()
        {
            this.validation.isMandatorPrenameDirty = true;
        },
        'caseData.mandator_surname': function()
        {
            this.validation.isMandatorSurnameDirty = true;
        },
        'caseData.mandator_mail': function()
        {
            this.validation.isMandatorMailDirty = true;
        },
        'caseData.mandator_iban': function()
        {
            this.validation.isMandatorIbanDirty = true;
        },
        'caseData.contract_number': function()
        {
            this.validation.isContractNumberDirty = true;
        },
        'caseData.monthly_gym_fee': function()
        {
            this.validation.isMonthlyGymFeeDirty = true;
        },
        'caseData.has_no_voucher_redeemed': function()
        {
            this.validation.isHasNoVoucherRedeemedDirty = true;
        },
        caseData: {
            handler: function()
            {
                this.onFormDataValidated();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
    .no-padding-left {
        padding-left: 0 !important;
    }

    .no-padding-right {
        padding-right: 0 !important;
    }

    .hint {
        position: relative;
        display: inline-block;
        width: 100%;
        margin-bottom: 10px;
        color: black!important;
        font-size: 0.875rem;
    }

    .hint i {
        color: #4d4d4d;
        border-bottom: 1px solid black;
        cursor: pointer;
    }

    .hint .hint-text {
        visibility: hidden;
        text-align: center;
        padding: 10px;
        border-radius: 6px;
        margin-top: 5px;
        font-style: normal;

        position: absolute;
        z-index: 10000;
        width: 100%;
        top: 100%;
        left: 0;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .hint i:hover .hint-text {
        visibility: visible;
    }

    .hint i:active .hint-text {
        visibility: visible;
    }

    .hint .hint-text::after {
        content: " ";
        position: absolute;
        bottom: 100%;
        left: 5%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent rgb(0 0 0 / 20%) transparent;
        color: #4f4f4f;
    }

    .gym-mail-input {
        margin-bottom: 2px;
    }

    .gym-mail-input.error {
        margin-bottom: 0px!important;
    }

    .gym-mail-input-container .error {
        margin-bottom: 2px;
    }

    h5 {
        font-weight: bold;
        font-size: 1.2rem;
        color: #4d4d4d;
        margin: 1.5rem 0 1rem 0;
    }

    .checkbox-margin {
        margin-bottom: 0;
        margin-right: 2px!important;
    }

    .error label {
        color: #4d4d4d;
    }

    .checkbox-label {
        display: flex;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .checkbox-label input[type=checkbox] {
        flex: none;
    }

    .checkbox-label span {
        margin-left: 10px;
        margin-top: -5px;
    }
</style>